import React, { useState } from "react";
import { arabicAlphabets } from "../data/arabicAlphabets";

function AlphabetGame() {
  const [score, setScore] = useState(0);
  const [shuffledAlphabets, setShuffledAlphabets] = useState(shuffleArray(arabicAlphabets));
  const [selectedLetter, setSelectedLetter] = useState(null);

  // Shuffle function to randomize alphabets
  function shuffleArray(array) {
    return array.sort(() => Math.random() - 0.5);
  }

  // Handle alphabet click event
  const handleLetterClick = (letter) => {
    if (letter === selectedLetter) {
      setScore(score + 1); // Increase score if the user clicks the correct letter
      setShuffledAlphabets(shuffleArray(arabicAlphabets)); // Shuffle the letters again
    } else {
      alert("Try Again!"); // If clicked letter is wrong
    }
  };

  // Function to start the game (or reset)
  const startGame = () => {
    setScore(0);
    setShuffledAlphabets(shuffleArray(arabicAlphabets));
    setSelectedLetter(arabicAlphabets[Math.floor(Math.random() * arabicAlphabets.length)]);
  };

  // Function to speak the letter
  const speak = (letter) => {
    if (window.responsiveVoice) {
      window.responsiveVoice.speak(letter, "Arabic Male");
    }
  };

  return (
    <div className="p-6 md:p-10 h-full bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 relative overflow-y-auto">
      {/* Modern background elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_80%,rgba(120,119,198,0.1),transparent_50%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(255,119,198,0.1),transparent_50%)]"></div>
      
      <h2 className="text-3xl font-bold text-center bg-gradient-to-r from-purple-600 via-pink-600 to-blue-600 bg-clip-text text-transparent mb-6 relative z-10">Arabic Alphabet Game</h2>
      <p className="text-xl text-center mb-8 text-gray-700 relative z-10">Click on the alphabet that matches the sound!</p>
      
      <div className="mb-6 text-center relative z-10">
        <h3 className="text-2xl font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-3">Score: {score}</h3>
        <button
          onClick={startGame}
          className="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 text-white px-6 py-3 rounded-full shadow-lg hover:scale-105 transition-all duration-300"
        >
          Start Game
        </button>
      </div>

      {selectedLetter && (
        <div className="text-center mb-8 relative z-10">
          <h3 className="text-2xl font-semibold bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent mb-3">
            Find this letter: {selectedLetter}
          </h3>
          <button
            className="bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white px-4 py-2 rounded-full shadow-lg hover:scale-105 transition-all duration-300"
            onClick={() => speak(selectedLetter)}
          >
            Listen to the Letter
          </button>
        </div>
      )}

      <div className="grid grid-cols-4 gap-6 relative z-10">
        {shuffledAlphabets.map((letter, index) => (
          <div
            key={index}
            className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 text-center cursor-pointer hover:scale-105 border border-white/30"
            onClick={() => handleLetterClick(letter)}
          >
            <div className="text-5xl text-purple-700">{letter}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AlphabetGame;
